import { createFromIconfontCN } from '@ant-design/icons-vue'

const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_3649224_qoyomvoiku.js',
  extraCommonProps: {
    class: 'icon'
  }
})

export function installIcon (app) {
  app.component('MyIcon', IconFont)
}
